module.exports = __webpack_public_path__ + "img/back_right.577429f0.svg";